"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6312],{

/***/ 21620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DeliveryWizardModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_SafeSuspenseLoading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11501);
/* harmony import */ var _components_V3_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1555);
/* harmony import */ var _components_V3_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12652);
/* harmony import */ var _helpers_analytics_events__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54646);
/* harmony import */ var _helpers_analytics_sendEvents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76110);
/* harmony import */ var _hooks_useEventsBaseProperties__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87037);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32533);
/* harmony import */ var _internals_AddressSelector__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15691);
/* harmony import */ var _internals_ChooseTimeAndPlace__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98485);
/* harmony import */ var _internals_hooks_useDeliveryWizardStep__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34794);
/* harmony import */ var _internals_hooks_usePreferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(38417);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var SELECTION_TYPES = {
    "choose:select": "saved selection",
    "create:search": "suggested"
};
var sendEvent = function(param, baseProperties) {
    var preferences = param.preferences, step = param.step, substep = param.substep, actionLocation = param.actionLocation;
    var ref, ref1;
    (0,_helpers_analytics_sendEvents__WEBPACK_IMPORTED_MODULE_6__/* .sendEvent */ .q)(_helpers_analytics_events__WEBPACK_IMPORTED_MODULE_5__/* .EVENTS.browse.addressSubmitted */ .F.browse.addressSubmitted, _objectSpread({
        selectionType: SELECTION_TYPES["".concat(step, ":").concat(substep)] || "manual",
        isPinAdjusted: false,
        deliveryType: preferences === null || preferences === void 0 ? void 0 : preferences.deliveryType,
        isAddressCoverage: (preferences === null || preferences === void 0 ? void 0 : preferences.deliveryType) !== "delivery" || !!(preferences === null || preferences === void 0 ? void 0 : preferences.storeId),
        isStoreOpen: !!(preferences === null || preferences === void 0 ? void 0 : (ref = preferences.store) === null || ref === void 0 ? void 0 : (ref1 = ref.schedule) === null || ref1 === void 0 ? void 0 : ref1.itsOpenNow),
        errorMessage: "",
        actionLocation: actionLocation,
        menuId: preferences === null || preferences === void 0 ? void 0 : preferences.menuId
    }, baseProperties));
};
function DeliveryWizardModal(param) {
    var onClose = param.onClose, isOpen = param.isOpen, _initialStep = param.initialStep, initialStep = _initialStep === void 0 ? "choose" : _initialStep, hideScheduleOptions = param.hideScheduleOptions, _actionLocation = param.actionLocation, actionLocation = _actionLocation === void 0 ? "" : _actionLocation, _canClickOutside = param.canClickOutside, canClickOutside = _canClickOutside === void 0 ? true : _canClickOutside, _highZIndex = param.highZIndex, highZIndex = _highZIndex === void 0 ? false : _highZIndex;
    var ref4;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialStep), step = ref2[0], setStep = ref2[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$G)("generic", {
        keyPrefix: "fields"
    }).t;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("select"), substep = ref3[0], setSubstep = ref3[1];
    var preferences = (0,_internals_hooks_usePreferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)().preferences;
    var eventBaseProperties = (0,_hooks_useEventsBaseProperties__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var disabled = (preferences === null || preferences === void 0 ? void 0 : preferences.deliveryType) === "delivery" ? !(preferences === null || preferences === void 0 ? void 0 : (ref4 = preferences.address) === null || ref4 === void 0 ? void 0 : ref4.address) : (preferences === null || preferences === void 0 ? void 0 : preferences.deliveryType) === "serve" ? !(preferences === null || preferences === void 0 ? void 0 : preferences.tableName) || !(preferences === null || preferences === void 0 ? void 0 : preferences.storeId) : !(preferences === null || preferences === void 0 ? void 0 : preferences.storeId);
    var onClick = function() {
        onClose();
        sendEvent({
            preferences: preferences,
            step: step,
            substep: substep,
            actionLocation: actionLocation
        }, eventBaseProperties);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isOpen || !(preferences === null || preferences === void 0 ? void 0 : preferences._id)) return;
        var ref;
        (0,_helpers_analytics_sendEvents__WEBPACK_IMPORTED_MODULE_6__/* .sendEvent */ .q)(_helpers_analytics_events__WEBPACK_IMPORTED_MODULE_5__/* .EVENTS.browse.addressModalViewed */ .F.browse.addressModalViewed, _objectSpread({
            actionLocation: actionLocation,
            menuId: (ref = preferences === null || preferences === void 0 ? void 0 : preferences.menuId) !== null && ref !== void 0 ? ref : ""
        }, eventBaseProperties));
    }, [
        isOpen,
        preferences === null || preferences === void 0 ? void 0 : preferences._id
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_internals_hooks_useDeliveryWizardStep__WEBPACK_IMPORTED_MODULE_11__/* .DeliveryWizardStepContext.Provider */ .K.Provider, {
        value: {
            setStep: setStep,
            step: step,
            setSubstep: setSubstep,
            substep: substep,
            onClose: onClose
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_V3_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            onClose: onClose,
            isOpen: isOpen,
            compact: true,
            canClickOutside: canClickOutside,
            highZIndex: highZIndex,
            className: "dark:bg-zinc-800 font-sans",
            footer: step === "create" ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "p-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_V3_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    primary: true,
                    full: true,
                    big: true,
                    onClick: onClick,
                    disabled: disabled,
                    children: t("confirm")
                })
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SafeSuspenseLoading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-gray-100 dark:bg-zinc-700",
                    children: step === "choose" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_internals_ChooseTimeAndPlace__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        hideScheduleOptions: hideScheduleOptions
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_internals_AddressSelector__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                })
            })
        })
    });
};


/***/ }),

/***/ 16312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_DeliveryWizard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/index.tsx + 15 modules
var ChooseTimeAndPlace = __webpack_require__(98485);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/useDeliveryWizardStep.ts
var useDeliveryWizardStep = __webpack_require__(34794);
// EXTERNAL MODULE: ./src/components/SafeSuspenseLoading/index.tsx
var SafeSuspenseLoading = __webpack_require__(11501);
// EXTERNAL MODULE: ./src/components/V3/Modal/index.tsx + 1 modules
var Modal = __webpack_require__(12652);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/AddressSelector/index.tsx + 6 modules
var AddressSelector = __webpack_require__(15691);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/exportables/DeliveryWizardComponent.tsx







function DeliveryWizardComponent() {
    var ref = (0,react.useState)("choose"), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)("search"), substep = ref1[0], setSubstep = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "rounded-xl py-1 shadow-md border-gray-100 bg-white dark:bg-zinc-800 dark:border-zinc-800 border-2 my-2 transition-all font-sans",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspenseLoading/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(useDeliveryWizardStep/* DeliveryWizardStepContext.Provider */.K.Provider, {
                value: {
                    setStep: setStep,
                    step: step,
                    setSubstep: setSubstep,
                    substep: substep
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-gray-100 dark:bg-zinc-700",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseTimeAndPlace/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        onClose: function() {
                            return setStep("choose");
                        },
                        isOpen: step === "create",
                        compact: true,
                        className: "dark:bg-zinc-800 font-sans",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-gray-100 dark:bg-zinc-700",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressSelector/* default */.Z, {})
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/DeliveryWizard/exportables/DeliveryWizardModal.tsx
var DeliveryWizardModal = __webpack_require__(21620);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/index.tsx


var DeliveryWizard = {
    AsModal: DeliveryWizardModal["default"],
    AsComponent: DeliveryWizardComponent
};
/* harmony default export */ var components_DeliveryWizard = (DeliveryWizard);


/***/ }),

/***/ 15691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AddressSelector; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/V3/Button/index.tsx
var Button = __webpack_require__(1555);
// EXTERNAL MODULE: ./src/helpers/logger/index.ts + 2 modules
var logger = __webpack_require__(80251);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Shared/AddressCard.tsx
var AddressCard = __webpack_require__(20002);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/hooks/useClaimAddressMutation.address.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        mutation ClaimAddress($addressRefString: String!) {\n          claimAddress(addressRefString: $addressRefString) {\n            id\n            provider\n          }\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

function useClaimAddressMutate() {
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    return function(addressRefString) {
        return mutate({
            mutation: (0,apollo_hooks_es/* gql */.Ps)(_templateObject()),
            variables: {
                addressRefString: addressRefString
            },
            clientName: "addresses"
        });
    };
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/usePreferencesForAddressContext.main.ts
var usePreferencesForAddressContext_main = __webpack_require__(38417);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/fragments/preferencesForAddressContext.main.ts
var preferencesForAddressContext_main = __webpack_require__(5172);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/hooks/useSetPlaceIdInPreferences.ts
function useSetPlaceIdInPreferences_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useSetPlaceIdInPreferences_templateObject() {
    var data = useSetPlaceIdInPreferences_taggedTemplateLiteral([
        "\n        mutation setPlaceIdInPreferences($websiteId: ID, $placeId: ID) {\n          setUserPreferences(websiteId: $websiteId, placeId: $placeId) {\n            _id\n            ...preferencesForAddressContext\n          }\n        }\n        ",
        "\n      "
    ]);
    useSetPlaceIdInPreferences_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useSetPlaceIdInPreferences() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    return function(placeId) {
        return mutate({
            mutation: (0,apollo_hooks_es/* gql */.Ps)(useSetPlaceIdInPreferences_templateObject(), preferencesForAddressContext_main/* preferencesForAddressContext */.P),
            variables: {
                placeId: placeId,
                websiteId: websiteId
            },
            refetchQueries: [
                "getUserAddresses"
            ]
        });
    };
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/hooks/useDeleteAddressMutation.main.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useDeleteAddressMutation_main_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function useDeleteAddressMutation_main_templateObject() {
    var data = useDeleteAddressMutation_main_taggedTemplateLiteral([
        "\n        mutation deleteAddress($addressId: ID!) {\n          deleteAddress(addressId: $addressId)\n        }\n      "
    ]);
    useDeleteAddressMutation_main_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useDeleteAddressMutation() {
    var preferences = (0,usePreferencesForAddressContext_main/* default */.Z)().preferences;
    var setPlaceId = useSetPlaceIdInPreferences();
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    return function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(addressId) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,apollo_hooks_es/* gql */.Ps)(useDeleteAddressMutation_main_templateObject()),
                            variables: {
                                addressId: addressId
                            },
                            refetchQueries: [
                                "getUserAddresses"
                            ]
                        });
                    case 3:
                        if (((ref = preferences.address) === null || ref === void 0 ? void 0 : ref._id) === addressId) {
                            setPlaceId(null);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(addressId) {
            return _ref.apply(this, arguments);
        };
    }();
};

// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/useDeliveryWizardStep.ts
var useDeliveryWizardStep = __webpack_require__(34794);
// EXTERNAL MODULE: ./src/helpers/misc/classnames.ts
var classnames = __webpack_require__(89894);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/hooks/useUserAddresses.main.ts
function useUserAddresses_main_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useUserAddresses_main_templateObject() {
    var data = useUserAddresses_main_taggedTemplateLiteral([
        "\n  query getUserAddresses {\n    addresses {\n      _id\n      address\n      addressLine2\n      addressSecondary\n      placeId\n      comment\n    }\n  }\n"
    ]);
    useUserAddresses_main_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var getUserAddressesQuery = (0,lib["default"])(useUserAddresses_main_templateObject());
function useUserAddresses() {
    var ref = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: getUserAddressesQuery
    }), addresses = ref.addresses, loading = ref.loading, error = ref.error;
    return {
        addresses: addresses,
        loading: loading,
        error: error
    };
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/AddressSelector/AddressesList.tsx







function AddressesList(param) {
    var onSelect = param.onSelect, onDelete = param.onDelete;
    var addresses = useUserAddresses().addresses;
    var substep = (0,useDeliveryWizardStep/* default */.Z)().substep;
    var ref = (0,react.useState)(null), placeIdForDeletion = ref[0], setPlaceIdForDeletion = ref[1];
    var filteredAddresses = addresses === null || addresses === void 0 ? void 0 : addresses.reverse();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,classnames/* default */.Z)("overflow-y-scroll overflow-x-hidden transition-all", substep === "search-focus" ? "max-h-20" : "max-h-72"),
            children: filteredAddresses === null || filteredAddresses === void 0 ? void 0 : filteredAddresses.map(function(address, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "relative group hover:bg-gray-50 rounded-md w-full cursor-pointer dark:hover:bg-gray-600",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,classnames/* default */.Z)("flex flew-row flex-nowrap justify-between items-strech max-w-full w-full", placeIdForDeletion === address.placeId ? "opacity-40" : "opacity-100"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flew-row grow justify-start items-center p-2 min-w-0",
                                    onClick: function() {
                                        if (placeIdForDeletion === address.placeId) return setPlaceIdForDeletion(null);
                                        onSelect(address);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdPin */.Qg_, {
                                            className: "w-8 flex-none"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col grow overflow-clip justify-start text-left items-start min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-ellipsis overflow-hidden whitespace-nowrap font-semibold text-sm max-w-full",
                                                    children: [
                                                        address === null || address === void 0 ? void 0 : address.address,
                                                        (address === null || address === void 0 ? void 0 : address.addressLine2) ? ", ".concat(address === null || address === void 0 ? void 0 : address.addressLine2, " ") : ""
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-ellipsis overflow-hidden whitespace-nowrap font-normal text-xs text-zinc-500 dark:text-zinc-200 max-w-full",
                                                    children: address === null || address === void 0 ? void 0 : address.addressSecondary
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-none hover:text-zinc-400 w-20 justify-center items-center self-stretch hover:bg-gray-100",
                                    onClick: function() {
                                        setPlaceIdForDeletion(address.placeId);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdMoreVert */.rgS, {
                                        className: "p-2 w-8 h-8"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: function() {
                                return onDelete(address);
                            },
                            className: (0,classnames/* default */.Z)("absolute top-0 bg-rose-700 hover:bg-rose-600 h-full text-white text-xs p-5 font-bold w-32 transition-all", placeIdForDeletion === address.placeId ? "right-0" : " -right-32"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdTrash */.hME, {}),
                                " Eliminar"
                            ]
                        })
                    ]
                }, index);
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/Loading/index.tsx
var Loading = __webpack_require__(69528);
// EXTERNAL MODULE: ./src/hooks/useCountryCode.ts
var useCountryCode = __webpack_require__(50900);
// EXTERNAL MODULE: ./src/hooks/useExperiment.experiments.tsx
var useExperiment_experiments = __webpack_require__(13505);
// EXTERNAL MODULE: ./src/hooks/useIsDarkMode.ts
var useIsDarkMode = __webpack_require__(54731);
// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/AddressSelector/ViteAddressIframe.tsx








var env = (0,getEnv/* default */.Z)();
var components_url = {
    local: "http://components.internal:5140",
    dev: "https://components.bejusto.com",
    prod: "https://components.getjusto.com"
}[env] || "https://components.getjusto.com";
function ViteAddressIframe(param) {
    var onAbort = param.onAbort, onConfirm = param.onConfirm, onStep = param.onStep;
    var ref, ref1;
    var countryCode = (0,useCountryCode/* default */.Z)();
    var ref2 = (0,react.useState)(true), loading = ref2[0], setLoading = ref2[1];
    var darkMode = (0,useIsDarkMode/* default */.Z)();
    var design = (0,useInitialData/* default */.Z)().design;
    var iframeRef = (0,react.useRef)(null);
    var awsOrGoogle = (0,useExperiment_experiments/* default */.Z)("address-provider-aws-or-google");
    var componentUrl = "".concat(components_url, "/address-form?appIdentifier=websites&provider=").concat(awsOrGoogle ? awsOrGoogle : "google", "&countryCode=").concat(countryCode, "&darkMode=").concat(darkMode, "&primaryColor=").concat(design === null || design === void 0 ? void 0 : (ref = design.design) === null || ref === void 0 ? void 0 : (ref1 = ref.primaryColor) === null || ref1 === void 0 ? void 0 : ref1.replace("#", ""));
    (0,react.useEffect)(function() {
        var handler = function(event) {
            console.log("Received message from iframe");
            if (event.data.type === "resize") {
                console.log("Received resize message from iframe", event.data.height);
                iframeRef.current.style.height = event.data.height + "px";
            }
            if (event.data.type === "success") {
                console.log("Received success message from iframe", event.data.address);
                onConfirm(event.data.address);
            }
            if (event.data.type === "failed") {
                console.log("Received failed message from iframe", event.data.error);
                onAbort(event.data.error);
            }
            if (event.data.type === "step") {
                console.log("Received step message from iframe", event.data.step);
                onStep(event.data.step);
            }
            if (event.data.type === "loaded") {
                // Prefered message instead of using the iframe load event because it consider internal iframe load events
                console.log("Received loaded message from iframe");
                setLoading(false);
            }
        };
        window.addEventListener("message", handler);
        return function() {
            return window.removeEventListener("message", handler);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 w-full h-full flex flex-row items-center justify-center bg-white dark:bg-zinc-800",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                ref: iframeRef,
                title: "V3 Address Form",
                className: "w-full flex items-center justify-center",
                src: componentUrl,
                allow: "geolocation",
                sandbox: "allow-scripts allow-same-origin"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/AddressSelector/index.tsx















function AddressSelector() {
    var setPlaceIdInPreferences = useSetPlaceIdInPreferences();
    var ref = (0,useDeliveryWizardStep/* default */.Z)(), setStep = ref.setStep, substep = ref.substep, setSubstep = ref.setSubstep;
    var claimAddress = useClaimAddressMutate();
    var ref1 = (0,react.useState)(null), confirmDeletion = ref1[0], setConfirmDeletion = ref1[1];
    var ref2 = (0,react.useState)(false), deleting = ref2[0], setDeleting = ref2[1];
    var deleteAddress = useDeleteAddressMutation();
    var showMessage = (0,useMessage/* default */.Z)();
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "delivery.create"
    }).t;
    return confirmDeletion ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressCard/* default */.Z, {
        shadow: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col divide-y dark:divide-gray-700 space-y-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosWarning */.SVk, {
                            className: "text-red-500 w-12 h-12"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-center text-xl",
                            children: t("delete.title")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center justify-center pt-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("delete.description")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "text-ellipsis overflow-hidden whitespace-nowrap min-w-0 max-w-full",
                            children: [
                                confirmDeletion.address,
                                confirmDeletion.addressSecondary
                            ].filter(function(v) {
                                return !!v;
                            }).join(", ")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center pt-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            danger: true,
                            loading: deleting,
                            big: true,
                            onClick: function() {
                                setDeleting(true);
                                deleteAddress(confirmDeletion._id).then(function() {
                                    setConfirmDeletion(null);
                                }).catch(function(error) {
                                    console.log(error);
                                    showMessage(error);
                                }).finally(function() {
                                    setDeleting(false);
                                });
                            },
                            children: t("delete.confirm")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            big: true,
                            onClick: function() {
                                setConfirmDeletion(null);
                            },
                            children: t("delete.cancel")
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            substep !== "confirm" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressCard/* default */.Z, {
                    shadow: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center mb-2 mx-4 pb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdArrowBack */.KYK, {
                                    className: "w-6 h-6 mr-4 cursor-pointer text-black hover:text-gray-700 dark:text-white dark:hover:text-gray-300",
                                    onClick: function() {
                                        return setStep("choose");
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: " text-lg",
                                    children: t("title")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressesList, {
                            onSelect: function(address) {
                                setPlaceIdInPreferences(address.placeId).then(function() {
                                    setStep("choose");
                                    setSubstep("select");
                                });
                            },
                            onDelete: setConfirmDeletion
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ViteAddressIframe, {
                onAbort: function(error) {
                    if (error) {
                        showMessage("Lo sentimos, ocurri\xf3 un error al guardar tu direcci\xf3n: " + error.message);
                        logger/* default.error */.Z.error("ViteAddressIFrame abort with error", error);
                    }
                    setStep("create");
                },
                onConfirm: function(newAddress) {
                    if (newAddress) {
                        var placeId = newAddress.placeId;
                        claimAddress(placeId).then(function() {
                            return setPlaceIdInPreferences(placeId);
                        }).then(function() {
                            setStep("choose");
                            setSubstep("search");
                        }).catch(function(err) {
                            showMessage("Lo sentimos, ocurri\xf3 un error al guardar tu direcci\xf3n: " + err.message);
                            logger/* default.error */.Z.error("Error claimAddress", err);
                        });
                    }
                },
                onStep: setSubstep
            })
        ]
    });
};


/***/ }),

/***/ 20002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AddressCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89894);



function AddressCard(param) {
    var children = param.children, _shadow = param.shadow, shadow = _shadow === void 0 ? true : _shadow;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("px-4 py-5 bg-white dark:bg-zinc-800", {
            "shadow-sm border-gray-200 shadow-gray-200 dark:shadow-gray-700 dark:border-gray-700": shadow
        }),
        children: children
    });
};


/***/ }),

/***/ 98485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ChooseTimeAndPlace; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/index.tsx
var SuspenseLoading = __webpack_require__(75288);
// EXTERNAL MODULE: ./src/components/V3/Toggle/index.tsx
var Toggle = __webpack_require__(89221);
// EXTERNAL MODULE: ./src/helpers/websites/canSchedule.ts
var canSchedule = __webpack_require__(7281);
// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/useIsOutOfBounds.ts
var useIsOutOfBounds = __webpack_require__(58513);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/usePreferencesForAddressContext.main.ts
var usePreferencesForAddressContext_main = __webpack_require__(38417);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/useSetDeliveryTypeInPreferences.main.ts
var useSetDeliveryTypeInPreferences_main = __webpack_require__(91874);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/components/SubcomponentSkeleton.tsx


function SubcomponentSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col animate-pulse py-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-4 mb-3 h-14 bg-gray-200 dark:bg-gray-600 dark:border-gray-600 rounded"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-4 mb-3 h-14 bg-gray-200 dark:bg-gray-600 dark:border-gray-600 rounded"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-4 mb-3 h-14 bg-gray-200 dark:bg-gray-600 dark:border-gray-600 rounded"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/V3/loadingIndicators/Spinner/index.tsx
var Spinner = __webpack_require__(18899);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/useDeliveryWizardStep.ts
var useDeliveryWizardStep = __webpack_require__(34794);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Delivery/OutOfBounds.tsx









function OutOfBounds() {
    var ref;
    var ref1 = (0,useSetDeliveryTypeInPreferences_main/* default */.Z)(), setDeliveryTypeInPreferences = ref1.setDeliveryTypeInPreferences, loading = ref1.loading;
    var setStep = (0,useDeliveryWizardStep/* default */.Z)().setStep;
    var preferences = (0,usePreferencesForAddressContext_main/* default */.Z)().preferences;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "delivery.outOfBoundsDetails"
    }).t;
    var website = (0,useInitialData/* default */.Z)().website;
    var hasTakeout = website.deliveryTypes.includes("go");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white dark:bg-zinc-800 p-4 flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-lg font-bold",
                children: t("title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-gray-600 dark:text-gray-300 text-base",
                children: [
                    (preferences === null || preferences === void 0 ? void 0 : (ref = preferences.address) === null || ref === void 0 ? void 0 : ref.address) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "italic text-gray-500 dark:text-gray-400",
                        children: [
                            " ",
                            preferences.address.address
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("submittedAddress")
                    }),
                    " ",
                    t("isOutOfBounds")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center py-2 mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 border-gray-200 border-t dark:border-gray-600"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm px-4 text-gray-600 dark:text-gray-400",
                        children: t("options.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 border-gray-200 border-t dark:border-gray-600"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col divide-y divide-gray-100 dark:divide-gray-600 text-sm font-semibold cursor-pointer",
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center py-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                        size: "lg"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        hasTakeout ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-2 items-center p-4 transition-all duration-200 hover:bg-gray-200 dark:hover:bg-gray-600",
                            onClick: function() {
                                return setDeliveryTypeInPreferences("go");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdShoppingBag */.J$n, {
                                    className: "w-5 h-5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("options.takeout")
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-2 items-center p-4 transition-all duration-200 hover:bg-gray-200 dark:hover:bg-gray-600",
                            onClick: function() {
                                return setStep("create");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdLocationPin */.vcr, {
                                    className: "w-5 h-5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("options.changeAddress")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Shared/AddressCard.tsx
var AddressCard = __webpack_require__(20002);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Shared/ToggleLabel.tsx

function ToggleLabel(param) {
    var text = param.text, Icon = param.Icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "flex items-center whitespace-nowrap font-xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                className: "h-4 w-4 mr-1"
            }),
            text
        ]
    });
};

// EXTERNAL MODULE: ./src/components/SafeSuspense/index.tsx
var SafeSuspense = __webpack_require__(5822);
// EXTERNAL MODULE: ./src/components/V3/Button/index.tsx
var Button = __webpack_require__(1555);
// EXTERNAL MODULE: ./src/components/V3/Pill/index.tsx
var Pill = __webpack_require__(94279);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/hooks/usePreferencesForDelivery.main.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getPreferencesForDelivery($websiteId: ID) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          placeId\n          storeId\n          preferredDeliveryStoreId\n          website {\n            _id\n            showStoreName\n          }\n          store {\n            _id\n            name\n          }\n          address {\n            _id\n            address\n            addressSecondary\n            addressLine2\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function usePreferencesForDelivery() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var result = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first",
        omit: (0,isServerSide/* default */.Z)()
    });
    return {
        preferences: result.preferences,
        loading: result.loading
    };
};

// EXTERNAL MODULE: ./node_modules/simple-react-form/lib/index.js
var simple_react_form_lib = __webpack_require__(40191);
// EXTERNAL MODULE: ./src/components/V3/forms/Radio/index.tsx
var Radio = __webpack_require__(39800);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/hooks/useStores.main.ts
function useStores_main_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useStores_main_templateObject() {
    var data = useStores_main_taggedTemplateLiteral([
        "\n  query getStores($websiteId: ID) {\n    stores(websiteId: $websiteId) {\n      items {\n        _id\n        name\n        acceptServe\n        acceptGo\n        address {\n          address\n          addressLine2\n          placeId\n        }\n      }\n    }\n  }\n"
    ]);
    useStores_main_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var getStoresQuery = (0,lib["default"])(useStores_main_templateObject());
function useStores() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var ref2 = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: getStoresQuery,
        variables: {
            websiteId: websiteId
        }
    }), stores = ref2.stores, loading = ref2.loading, error = ref2.error;
    var storeTo = function(deliveryType) {
        var ref3, ref1;
        return stores === null || stores === void 0 ? void 0 : (ref3 = stores.items) === null || ref3 === void 0 ? void 0 : (ref1 = ref3.filter) === null || ref1 === void 0 ? void 0 : ref1.call(ref3, function(store) {
            var ref;
            if (!((ref = store.address) === null || ref === void 0 ? void 0 : ref.placeId)) return false;
            if (deliveryType === "go" && store.acceptGo) {
                return true;
            }
            if (deliveryType === "serve" && store.acceptServe) {
                return true;
            }
            return false;
        });
    };
    return {
        stores: stores,
        storeTo: storeTo,
        loading: loading,
        error: error
    };
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Shared/StoreSelector.tsx




function StoreSelector(param) {
    var deliveryType = param.deliveryType, stores = param.stores;
    var storeTo = useStores().storeTo;
    var options = (stores ? stores : storeTo(deliveryType)).map(function(store) {
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-gray-900 dark:text-white text-md font-semibold",
                children: [
                    store.name,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-gray-600 dark:text-gray-300 ml-2 font-normal",
                        children: [
                            store.address.address,
                            " ",
                            store.address.addressLine2
                        ]
                    })
                ]
            }),
            value: store._id
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-h-[380px] overflow-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
            fieldName: "storeId",
            type: Radio/* default */.Z,
            options: options
        })
    });
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Delivery/useStoresInCoverage.main.ts
function useStoresInCoverage_main_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useStoresInCoverage_main_templateObject() {
    var data = useStoresInCoverage_main_taggedTemplateLiteral([
        "\n      query storesInCoverage($websiteId: ID, $placeId: ID) {\n        stores: storesInCoverage(websiteId: $websiteId, placeId: $placeId) {\n          _id\n          name\n          address {\n            address\n            addressLine2\n          }\n        }\n      }\n    "
    ]);
    useStoresInCoverage_main_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function useStoresInCoverage() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var preferences = usePreferencesForDelivery().preferences;
    var stores = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(useStoresInCoverage_main_templateObject()),
        variables: {
            websiteId: websiteId,
            placeId: preferences.placeId
        }
    }).stores;
    return stores;
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Delivery/ChangePreferredStore.tsx
function ChangePreferredStore_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ChangePreferredStore_templateObject() {
    var data = ChangePreferredStore_taggedTemplateLiteral([
        "\n        mutation setPreferredDeliveryStore($websiteId: ID, $preferredDeliveryStoreId: ID) {\n          setUserPreferences(\n            websiteId: $websiteId\n            preferredDeliveryStoreId: $preferredDeliveryStoreId\n          ) {\n            _id\n            preferredDeliveryStoreId\n            store {\n              _id\n              name\n              address {\n                address\n                addressLine2\n              }\n            }\n          }\n        }\n      "
    ]);
    ChangePreferredStore_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











function ChangePreferredStore() {
    var stores = useStoresInCoverage();
    var preferences = usePreferencesForDelivery().preferences;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "delivery.delivery"
    }).t;
    var ref = (0,react.useState)({
        storeId: preferences.preferredDeliveryStoreId
    }), formState = ref[0], setFormState = ref[1];
    var setSubstep = (0,useDeliveryWizardStep/* default */.Z)().setSubstep;
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var setPreferredStoreId = function(storeId) {
        return mutate({
            mutation: (0,lib["default"])(ChangePreferredStore_templateObject()),
            variables: {
                websiteId: websiteId,
                preferredDeliveryStoreId: storeId
            }
        });
    };
    if (!(stores === null || stores === void 0 ? void 0 : stores.length)) {
        return null;
    }
    if (stores.length <= 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-lg font-semibold",
                children: t("changeStore")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Form, {
                state: formState,
                onChange: function(newState) {
                    setPreferredStoreId(newState.storeId).then(function(result) {
                        setSubstep(null);
                    }).catch(function(error) {
                        console.log("setStoreIdError", error);
                    });
                    setFormState(newState);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreSelector, {
                    deliveryType: "delivery",
                    stores: stores
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Delivery/PreferredStoreInfo.tsx






function PreferredStoreInfo() {
    var ref, ref1;
    var preferences = usePreferencesForDelivery().preferences;
    var stores = useStoresInCoverage();
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "delivery.delivery"
    }).t;
    var ref2 = (0,esm/* useTranslation */.$G)("generic", {
        keyPrefix: "fields"
    }), tGeneric = ref2.t;
    var setSubstep = (0,useDeliveryWizardStep/* default */.Z)().setSubstep;
    if ((preferences === null || preferences === void 0 ? void 0 : (ref = preferences.website) === null || ref === void 0 ? void 0 : ref.showStoreName) !== true || !(preferences === null || preferences === void 0 ? void 0 : preferences.storeId) || !(stores === null || stores === void 0 ? void 0 : stores.length) || stores.length <= 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-sm p-2 text-gray-500 dark:text-gray-400",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    t("currentStore", {
                        storeName: (ref1 = preferences.store) === null || ref1 === void 0 ? void 0 : ref1.name
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "underline cursor-pointer",
                onClick: function() {
                    return setSubstep("change-preferred-store");
                },
                children: tGeneric("change")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Delivery/index.tsx










var addressStringParse = function(address) {
    return [
        address === null || address === void 0 ? void 0 : address.addressLine2,
        address === null || address === void 0 ? void 0 : address.address,
        address === null || address === void 0 ? void 0 : address.addressSecondary
    ].filter(function(v) {
        return !!v;
    }).join(", ");
};
function DeliveryInner() {
    var ref = (0,useDeliveryWizardStep/* default */.Z)(), setStep = ref.setStep, substep = ref.substep;
    var preferences = usePreferencesForDelivery().preferences;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "delivery.delivery"
    }).t;
    var ref1 = (0,esm/* useTranslation */.$G)("generic", {
        keyPrefix: "fields"
    }), tGeneric = ref1.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: preferences.placeId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: substep === "change-preferred-store" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePreferredStore, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flew-row justify-between items-center min-w-0 cursor-pointer",
                        onClick: function() {
                            return setStep("create");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineTwoWheeler */.Q$H, {
                                className: "w-10 mx-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-ellipsis overflow-hidden whitespace-nowrap font-semibold text-sm",
                                children: [
                                    t("label"),
                                    ":",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-normal",
                                        children: addressStringParse(preferences.address)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.Z, {
                                className: "text-xs ml-5",
                                showCaret: false,
                                children: tGeneric("change")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreferredStoreInfo, {})
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            big: true,
            full: true,
            primary: true,
            className: "rounded-xl",
            onClick: function() {
                return setStep("create");
            },
            children: t("addAddress")
        })
    });
}
var Skeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-4 animate-pulse",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-6 flex-1 bg-gray-300 dark:bg-gray-600 rounded"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-6 w-24 bg-gray-300 dark:bg-gray-600 rounded"
            })
        ]
    });
};
function Delivery() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInner, {})
    });
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/hooks/useStoreIdInPreferences.ts
function useStoreIdInPreferences_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useStoreIdInPreferences_templateObject() {
    var data = useStoreIdInPreferences_taggedTemplateLiteral([
        "\n        mutation setStoreIdInPreferences($websiteId: ID, $storeId: ID) {\n          setUserPreferences(websiteId: $websiteId, storeId: $storeId) {\n            _id\n            storeId\n            menuId\n            store {\n              minimumAnticipationDays\n              availableScheduleDaysOptions {\n                label\n                value\n              }\n              schedule {\n                itsOpenNow: itsAvailableAt(websiteId: $websiteId)\n              }\n            }\n          }\n        }\n      "
    ]);
    useStoreIdInPreferences_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useSetStoreIdInPreferences() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    return function(storeId) {
        return mutate({
            mutation: (0,apollo_hooks_es/* gql */.Ps)(useStoreIdInPreferences_templateObject()),
            variables: {
                storeId: storeId,
                websiteId: websiteId
            }
        });
    };
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Go.tsx








function GoInner() {
    var preferences = (0,usePreferencesForAddressContext_main/* default */.Z)().preferences;
    var setStoreId = useSetStoreIdInPreferences();
    var ref = (0,react.useState)({
        storeId: preferences.storeId
    }), formState = ref[0], setFormState = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Form, {
            state: formState,
            onChange: function(newState) {
                setStoreId(newState.storeId).then(function(result) {}).catch(function(error) {
                    console.log("setStoreIdError", error);
                });
                setFormState(newState);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreSelector, {
                deliveryType: "go"
            })
        })
    });
}
function Go() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubcomponentSkeleton, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoInner, {})
    });
};

// EXTERNAL MODULE: ./src/components/SafeSuspenseLoading/index.tsx
var SafeSuspenseLoading = __webpack_require__(11501);
// EXTERNAL MODULE: ./src/components/ScheduleForm/index.tsx + 4 modules
var ScheduleForm = __webpack_require__(44272);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Schedule/index.tsx




function Schedule(props) {
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "delivery.schedule"
    }).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SafeSuspenseLoading/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mb-5 text-xl",
                children: t("title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleForm/* default */.Z, {
                onClose: props.onClose,
                autosave: true
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/V3/forms/Text/index.tsx
var Text = __webpack_require__(55615);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/hooks/useSetServePreferences.ts
function useSetServePreferences_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useSetServePreferences_templateObject() {
    var data = useSetServePreferences_taggedTemplateLiteral([
        "\n        mutation setServePreferences($websiteId: ID, $storeId: ID, $tableName: String) {\n          setUserPreferences(websiteId: $websiteId, storeId: $storeId, tableName: $tableName) {\n            _id\n            tableName\n            storeId\n            store {\n              minimumAnticipationDays\n              availableScheduleDaysOptions {\n                label\n                value\n              }\n              schedule {\n                itsOpenNow: itsAvailableAt(websiteId: $websiteId)\n              }\n            }\n          }\n        }\n      "
    ]);
    useSetServePreferences_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function useSetServePreferences() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var showMessage = (0,useMessage/* default */.Z)();
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "delivery.edit"
    }).t;
    return function(param) {
        var storeId = param.storeId, tableName = param.tableName;
        return mutate({
            mutation: (0,apollo_hooks_es/* gql */.Ps)(useSetServePreferences_templateObject()),
            variables: {
                storeId: storeId,
                websiteId: websiteId,
                tableName: tableName
            }
        }).then(function() {
        // showMessage(t('success'))
        });
    };
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/Serve.tsx












function ServeInner() {
    var ref = (0,usePreferencesForAddressContext_main/* default */.Z)(), preferences = ref.preferences, loading = ref.loading;
    var setServePreferences = useSetServePreferences();
    var onClose = (0,useDeliveryWizardStep/* default */.Z)().onClose;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "delivery.serve"
    }).t;
    var ref1 = (0,react.useState)({
        tableName: preferences.tableName,
        storeId: preferences.storeId
    }), formState = ref1[0], setFormState = ref1[1];
    var changesOnTable = formState.tableName !== preferences.tableName || formState.storeId !== preferences.storeId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(simple_react_form_lib.Form, {
                state: formState,
                onChange: setFormState,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreSelector, {
                        deliveryType: "serve"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
                        fieldName: "tableName",
                        type: Text/* default */.Z,
                        label: t("label"),
                        placeholder: t("placeholder")
                    })
                ]
            }),
            changesOnTable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "mt-4",
                full: true,
                primary: true,
                onClick: function() {
                    setServePreferences(formState).then(function(result) {
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                        console.log("setServePreferencesSet", result);
                    }).catch(function(error) {
                        console.log("setServePreferencesError", error);
                    });
                },
                children: "Fijar mesa"
            })
        ]
    });
}
function Serve() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubcomponentSkeleton, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServeInner, {})
    });
};

;// CONCATENATED MODULE: ./src/components/DeliveryWizard/internals/ChooseTimeAndPlace/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



















var componentMap = {
    delivery: Delivery,
    serve: Serve,
    go: Go
};
function ChooseTimeAndPlace(props) {
    var t = (0,esm/* useTranslation */.$G)("generic", {
        keyPrefix: "fields.deliveryType"
    }).t;
    var ref = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "delivery"
    }), tDelivery = ref.t;
    var preferences = (0,usePreferencesForAddressContext_main/* default */.Z)().preferences;
    var ref1 = (0,useSetDeliveryTypeInPreferences_main/* default */.Z)(), setDeliveryTypeInPreferences = ref1.setDeliveryTypeInPreferences, loading = ref1.loading;
    var ref2 = (0,react.useState)(preferences.deliveryType), deliveryTypeBuffer = ref2[0], setDeliveryTypeBuffer = ref2[1];
    var website = (0,useInitialData/* default */.Z)().website;
    (0,react.useEffect)(function() {
        setDeliveryTypeBuffer(preferences.deliveryType);
    }, [
        preferences.deliveryType
    ]);
    var isOutOfBounds = (0,useIsOutOfBounds/* default */.Z)();
    var labels = {
        delivery: {
            Icon: index_esm/* MdOutlineTwoWheeler */.Q$H,
            text: t("delivery")
        },
        go: {
            Icon: index_esm/* MdOutlineShoppingBag */.t5$,
            text: "Retirar"
        },
        serve: {
            Icon: index_esm/* MdOutlineRestaurant */._Cs,
            text: t("serve")
        }
    };
    if (isOutOfBounds) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfBounds, {});
    }
    var showScheduleOptions = preferences.deliveryType !== "serve" && preferences.storeId && (0,canSchedule/* default */.Z)(preferences.store) && props.hideScheduleOptions !== true;
    var Subcomponent = componentMap[preferences.deliveryType];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressCard/* default */.Z, {
                        shadow: false,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-xl font-bold mb-5",
                                children: tDelivery("title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                                itemClassName: "!px-0 md:px-5",
                                options: Object.keys(labels).filter(function(key) {
                                    return website.deliveryTypes.includes(key) && labels[key];
                                }).map(function(key) {
                                    return {
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleLabel, _objectSpread({}, labels[key])),
                                        value: key
                                    };
                                }),
                                onChange: function(value) {
                                    setDeliveryTypeBuffer(value);
                                    setDeliveryTypeInPreferences(value).then(function(result) {}).catch(function(error) {
                                        setDeliveryTypeBuffer(preferences.deliveryType);
                                    });
                                },
                                value: deliveryTypeBuffer
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressCard/* default */.Z, {
                        shadow: showScheduleOptions,
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubcomponentSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Subcomponent, {})
                        })
                    })
                ]
            }),
            showScheduleOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressCard/* default */.Z, {
                shadow: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Schedule, {
                    onClose: props.onSave
                })
            })
        ]
    });
};


/***/ }),

/***/ 5172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ preferencesForAddressContext; }
/* harmony export */ });
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment preferencesForAddressContext on Preference {\n    _id\n    deliveryType\n    tableName\n    storeId\n    shouldHidePrice\n    store {\n      _id\n      name\n      minimumAnticipationDays\n      availableScheduleDaysOptions {\n        label\n        value\n      }\n      schedule {\n        itsOpenNow: itsAvailableAt(websiteId: $websiteId)\n      }\n    }\n    placeId\n    address {\n      _id\n      address\n      addressSecondary\n      addressLine2\n    }\n    menuId\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var preferencesForAddressContext = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject());


/***/ }),

/***/ 34794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ DeliveryWizardStepContext; },
/* harmony export */   "Z": function() { return /* binding */ useDeliveryWizardStep; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var DeliveryWizardStepContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    step: "choose",
    setStep: function() {},
    substep: "search",
    setSubstep: function() {},
    onClose: function() {}
});
function useDeliveryWizardStep() {
    return react__WEBPACK_IMPORTED_MODULE_0__.useContext(DeliveryWizardStepContext);
};


/***/ }),

/***/ 58513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsOutOfBounds; }
/* harmony export */ });
/* harmony import */ var _usePreferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38417);

function useIsOutOfBounds() {
    var preferences = (0,_usePreferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().preferences;
    if (!(preferences === null || preferences === void 0 ? void 0 : preferences.placeId)) return false;
    if ((preferences === null || preferences === void 0 ? void 0 : preferences.deliveryType) === "delivery" && !(preferences === null || preferences === void 0 ? void 0 : preferences.storeId)) {
        return true;
    }
    return false;
};


/***/ }),

/***/ 38417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePreferencesForAddressContext; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90257);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50456);
/* harmony import */ var _fragments_preferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5172);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getPreferencesForAddressContext($websiteId: ID) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          ...preferencesForAddressContext\n        }\n      }\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function usePreferencesForAddressContext() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var result = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__["default"])(_templateObject(), _fragments_preferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_2__/* .preferencesForAddressContext */ .P),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first",
        // pollInterval: 1000 * 60 * 10,
        omit: (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)()
    });
    return {
        preferences: result.preferences,
        loading: result.loading
    };
};


/***/ }),

/***/ 91874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSetDeliveryTypeInPreferences; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src312353053_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src312353053_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src312353053_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5528);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3172);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32533);
/* harmony import */ var _fragments_preferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5172);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        mutation setDeliveryTypeInPreferences($websiteId: ID, $deliveryType: ID) {\n          setUserPreferences(websiteId: $websiteId, deliveryType: $deliveryType) {\n            _id\n            ...preferencesForAddressContext\n          }\n        }\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function useSetDeliveryTypeInPreferences() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var mutate = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useMutate */ .Tu)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref[0], setLoading = ref[1];
    var showMessage = (0,_hooks_useMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("website", {
        keyPrefix: "delivery.edit"
    }).t;
    var setDeliveryTypeInPreferences = function() {
        var _ref = _asyncToGenerator(_codebuild_output_src312353053_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(deliveryType) {
            var result;
            return _codebuild_output_src312353053_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject(), _fragments_preferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_6__/* .preferencesForAddressContext */ .P),
                            variables: {
                                deliveryType: deliveryType,
                                websiteId: websiteId
                            }
                        }).finally(function() {
                            return setLoading(false);
                        });
                    case 3:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", result);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function setDeliveryTypeInPreferences(deliveryType) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        setDeliveryTypeInPreferences: setDeliveryTypeInPreferences,
        loading: loading
    };
};


/***/ }),

/***/ 44272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ScheduleForm; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/index.tsx
var SuspenseLoading = __webpack_require__(75288);
// EXTERNAL MODULE: ./src/components/V3/Button/index.tsx
var Button = __webpack_require__(1555);
// EXTERNAL MODULE: ./src/components/V3/Toggle/index.tsx
var Toggle = __webpack_require__(89221);
// EXTERNAL MODULE: ./src/helpers/analytics/events/index.ts + 3 modules
var events = __webpack_require__(54646);
// EXTERNAL MODULE: ./src/helpers/analytics/sendEvents.ts
var sendEvents = __webpack_require__(76110);
// EXTERNAL MODULE: ./src/helpers/labels/dropOffTypeLabels.ts
var dropOffTypeLabels = __webpack_require__(31765);
// EXTERNAL MODULE: ./src/helpers/websites/canSchedule.ts
var canSchedule = __webpack_require__(7281);
// EXTERNAL MODULE: ./src/helpers/websites/scheduleHelpers.ts
var scheduleHelpers = __webpack_require__(3943);
// EXTERNAL MODULE: ./src/hooks/useEventsBaseProperties.ts
var useEventsBaseProperties = __webpack_require__(87037);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Select/index.js
var Select = __webpack_require__(97338);
// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./node_modules/simple-react-form/lib/index.js
var lib = __webpack_require__(40191);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var io_index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./src/helpers/websites/canDeliverNow.ts
var canDeliverNow = __webpack_require__(41695);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var graphql_tag_lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/components/ScheduleForm/hooks/useSchedulePreferences.main.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query preferencesForScheduleForm($websiteId: ID!) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          menuId\n          deliverAt\n          deliveryType\n          time\n          dropOffType\n          store {\n            _id\n            availableScheduleDaysOptions {\n              label\n              value\n            }\n            schedule {\n              itsOpenNow: itsAvailableAt(websiteId: $websiteId)\n            }\n            minimumAnticipationDays\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useSchedulePreferences() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var preferences = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,graphql_tag_lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        }
    }).preferences;
    return preferences;
};

;// CONCATENATED MODULE: ./src/components/ScheduleForm/hooks/useScheduleOptions.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useScheduleOptions_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function useScheduleOptions_templateObject() {
    var data = useScheduleOptions_taggedTemplateLiteral([
        "\n        mutation setTimePreferences($websiteId: ID, $time: String, $dropOffType: String) {\n          setUserPreferences(websiteId: $websiteId, time: $time, dropOffType: $dropOffType) {\n            _id\n            time\n            timeLabel\n            dropOffType\n            menuId\n          }\n        }\n      "
    ]);
    useScheduleOptions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











function useScheduleOptions() {
    var preferences = useSchedulePreferences();
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var ref = (0,react.useState)(preferences.time === "now"), deliverNow = ref[0], setDeliverNow = ref[1];
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "schedule"
    }).t;
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var savePreferences = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
            var time, dropOffType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        time = param.time, dropOffType = param.dropOffType;
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,graphql_tag_lib["default"])(useScheduleOptions_templateObject()),
                            variables: {
                                time: time,
                                dropOffType: dropOffType,
                                websiteId: websiteId
                            },
                            refetchQueries: [
                                "getMyOrderPreferences"
                            ]
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function savePreferences(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var error;
    if (deliverNow && !(0,canDeliverNow/* default */.Z)(preferences.store)) {
        error = t("errors.cantDeliverNow");
    }
    if (!deliverNow && !(0,canSchedule/* default */.Z)(preferences.store)) {
        error = t("errors.cantSchedule");
    }
    var options = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaRegClock */.fSQ, {
                        size: 14,
                        className: "mr-2"
                    }),
                    t("asSoonAsPossible")
                ]
            }),
            value: true
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(io_index_esm/* IoMdCalendar */.i95, {
                        size: 18,
                        className: "mr-2"
                    }),
                    t("scheduleOrder")
                ]
            }),
            value: false
        }
    ];
    return {
        deliverNow: deliverNow,
        setDeliverNow: setDeliverNow,
        options: options,
        error: error,
        savePreferences: savePreferences
    };
};

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/components/ScheduleForm/hooks/useTimeOptions.main.ts
function useTimeOptions_main_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useTimeOptions_main_templateObject() {
    var data = useTimeOptions_main_taggedTemplateLiteral([
        "\n      query getTimeOptionsCheckoutV3($websiteId: ID, $date: Date) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          timeOptions(date: $date) {\n            label\n            value\n            disabled\n          }\n        }\n      }\n    "
    ]);
    useTimeOptions_main_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function useTimeOptions(days) {
    var date = dayjs_min_default()().add(days, "days").startOf("day").add(3, "hours") // to fix tz issues
    .format();
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var ref = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,graphql_tag_lib["default"])(useTimeOptions_main_templateObject()),
        variables: {
            websiteId: websiteId,
            date: date
        },
        fetchPolicy: "network-only"
    }), preferences = ref.preferences, loading = ref.loading, networkStatus = ref.networkStatus;
    return {
        preferences: preferences,
        loading: loading,
        networkStatus: networkStatus,
        date: dayjs_min_default()().add(days, "days").format("L")
    };
};

// EXTERNAL MODULE: ./src/hooks/useScreenSize.ts
var useScreenSize = __webpack_require__(69347);
;// CONCATENATED MODULE: ./src/components/ScheduleForm/HourField.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








function HourField(props) {
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "schedule"
    }).t;
    var screenSize = (0,useScreenSize/* default */.Z)();
    var ref = useTimeOptions(props.days), preferences = ref.preferences, networkStatus = ref.networkStatus;
    var timeOptions = [];
    if (preferences === null || preferences === void 0 ? void 0 : preferences.timeOptions) {
        var queryOptions = preferences.timeOptions.map(function(option) {
            return _objectSpread({}, option, {
                isDisabled: option.disabled
            });
        });
        var isAnyOptionEnabled = queryOptions.some(function(option) {
            return !option.disabled;
        });
        var options = isAnyOptionEnabled ? queryOptions : [];
        timeOptions = options;
    }
    if ((timeOptions === null || timeOptions === void 0 ? void 0 : timeOptions.length) === 0 && networkStatus === 7) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "text-red-800 font-semibold",
            children: "Este d\xeda no tiene horarios disponibles"
        });
    } else if (networkStatus !== 7) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
        fieldName: "time",
        placeholder: t("selectTime"),
        noOptionsMessage: function() {
            return t("closedThisDay");
        },
        type: Select/* default */.Z,
        options: timeOptions,
        passProps: {
            menuPlacement: screenSize === "mobile" ? "top" : "bottom",
            styles: {
                option: function(styles, param) {
                    var isDisabled = param.isDisabled;
                    return _objectSpread({}, styles, {
                        textDecoration: isDisabled ? "line-through" : styles.textDecoration,
                        cursor: isDisabled ? "not-allowed" : "default"
                    });
                }
            }
        }
    });
};

;// CONCATENATED MODULE: ./src/components/ScheduleForm/index.tsx
function ScheduleForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ScheduleForm_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ScheduleForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ScheduleForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ScheduleForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ScheduleForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ScheduleForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






















function ScheduleForm(props1) {
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "schedule"
    }).t;
    var ref10 = (0,esm/* useTranslation */.$G)("generic"), tGeneric = ref10.t;
    var preferences = useSchedulePreferences();
    var timeOptions = useScheduleOptions();
    var showMessage = (0,useMessage/* default */.Z)();
    var eventBaseProperties = (0,useEventsBaseProperties/* default */.Z)();
    var ref1 = (0,react.useState)(false), submitting = ref1[0], setSubmitting = ref1[1];
    var ref2 = (0,react.useState)({
        days: (0,scheduleHelpers/* getTimeValue */.UM)(preferences.time).days,
        time: (0,scheduleHelpers/* getTimeValue */.UM)(preferences.time).time,
        dropOffType: preferences.dropOffType
    }), formState = ref2[0], setFormState = ref2[1];
    var _days;
    var ref3 = useTimeOptions((_days = formState.days) !== null && _days !== void 0 ? _days : 0), preferencesTime = ref3.preferences, date = ref3.date;
    var time = timeOptions.deliverNow ? "now" : !isNil_default()(formState.days) && !isNil_default()(formState.time) ? "".concat(formState.time, "+").concat(formState.days) : undefined;
    var isMounted = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // We don't want to submit on the first mount.
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        if (!props1.autosave) return;
        if ((0,scheduleHelpers/* isValidTime */.sC)(time, formState.days)) {
            onSubmit();
        }
    }, [
        time,
        formState.days
    ]);
    var onSubmit = function() {
        var _ref = ScheduleForm_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref4, ref5, ref6, ref7, ref8, scheduleTime, ref9;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (time) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if ((0,scheduleHelpers/* isValidTime */.sC)(time, formState.days)) {
                            _ctx.next = 5;
                            break;
                        }
                        showMessage(t("errors.invalidTime"));
                        return _ctx.abrupt("return");
                    case 5:
                        setSubmitting(true);
                        _ctx.prev = 6;
                        ;
                        _ctx.next = 10;
                        return timeOptions.savePreferences({
                            time: time,
                            dropOffType: formState.dropOffType
                        });
                    case 10:
                        scheduleTime = (timeOptions === null || timeOptions === void 0 ? void 0 : timeOptions.deliverNow) ? "" : (ref4 = preferencesTime === null || preferencesTime === void 0 ? void 0 : (ref = preferencesTime.timeOptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
                            return option.value === formState.time;
                        })) === null || ref4 === void 0 ? void 0 : ref4.label;
                        ;
                        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.browse.deliveryTypeScheduled */.F.browse.deliveryTypeScheduled, ScheduleForm_objectSpread({
                            scheduleAction: (timeOptions === null || timeOptions === void 0 ? void 0 : timeOptions.deliverNow) ? "now" : "schedule",
                            scheduleDate: date !== null && date !== void 0 ? date : "",
                            scheduleTime: scheduleTime !== null && scheduleTime !== void 0 ? scheduleTime : "",
                            isStoreOpen: preferences === null || preferences === void 0 ? void 0 : (ref5 = preferences.store) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.schedule) === null || ref6 === void 0 ? void 0 : ref6.itsOpenNow,
                            isOutOfStock: false,
                            menuId: (ref9 = preferences === null || preferences === void 0 ? void 0 : preferences.menuId) !== null && ref9 !== void 0 ? ref9 : ""
                        }, eventBaseProperties));
                        if (props1.showSuccessMessage) {
                            showMessage(t("updated"));
                        }
                        _ctx.next = 16;
                        return (ref7 = props1.onChangeTimePreferences) === null || ref7 === void 0 ? void 0 : ref7.call(props1);
                    case 16:
                        (ref8 = props1.onClose) === null || ref8 === void 0 ? void 0 : ref8.call(props1);
                        _ctx.next = 22;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](6);
                        showMessage(_ctx.t0);
                    case 22:
                        _ctx.prev = 22;
                        setSubmitting(false);
                        return _ctx.finish(22);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    19,
                    22,
                    25
                ]
            ]);
        }));
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var toggle = (0,canSchedule/* default */.Z)(preferences.store) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: props1.className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
            onChange: timeOptions.setDeliverNow,
            options: timeOptions.options,
            value: timeOptions.deliverNow
        })
    }) : null;
    if (timeOptions.error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: props1.className,
            children: [
                toggle,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-red",
                    children: timeOptions.error
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib.Form, {
            state: formState,
            onChange: setFormState,
            children: [
                toggle,
                timeOptions.deliverNow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: props1.soonestAvailableLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-4 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {
                            children: props1.soonestAvailableLabel
                        })
                    }) : null
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                            fieldName: "days",
                            placeholder: t("selectDay"),
                            type: Select/* default */.Z,
                            options: preferences.store.availableScheduleDaysOptions
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {
                            height: 40,
                            children: formState.days === undefined || formState.days === null ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(HourField, {
                                days: formState.days
                            })
                        })
                    ]
                }),
                preferences.deliveryType === "delivery" && props1.showDropOffSection ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "font-medium text-sm my-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdListAlt */.r4W, {
                                    size: 16,
                                    className: "mr-1"
                                }),
                                t("dropOffType")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                            fieldName: "dropOffType",
                            type: function(props) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, ScheduleForm_objectSpread({}, props, {
                                    passProps: {
                                        menuPlacement: "top"
                                    }
                                }));
                            },
                            options: Object.keys(dropOffTypeLabels/* default */.Z).map(function(key) {
                                return {
                                    label: dropOffTypeLabels/* default */.Z[key],
                                    value: key
                                };
                            })
                        })
                    ]
                }) : null,
                props1.autosave ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    full: true,
                    big: true,
                    primary: true,
                    onClick: onSubmit,
                    disabled: submitting || !time,
                    loading: submitting,
                    children: submitting ? null : tGeneric("fields.save")
                })
            ]
        })
    });
};


/***/ }),

/***/ 89221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Toggle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89894);
/* harmony import */ var _hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54731);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




function Toggle(param1) {
    var _options = param1.options, options = _options === void 0 ? [] : _options, currValue = param1.value, onChange = param1.onChange, itemClassName = param1.itemClassName;
    var currSelectedIndex = options.findIndex(function(param) {
        var value = param.value;
        return value === currValue;
    });
    var isDarkMode = (0,_hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            "flex rounded-full relative overflow-hidden": true,
            "bg-gray-100": !isDarkMode,
            "bg-gray-500 text-gray-300": isDarkMode
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    transform: "translateX(".concat(currSelectedIndex * 100, "%)"),
                    width: "".concat(100 / options.length, "%"),
                    zIndex: 0
                },
                className: "absolute h-full button-v3-primary rounded-full transition ease-out duration-150"
            }),
            options.map(function(param) {
                var value = param.value, label = param.label;
                var _obj;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: function() {
                        if (value === currValue) return;
                        onChange(value);
                    },
                    style: {
                        zIndex: 1
                    },
                    className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_obj = {}, _defineProperty(_obj, itemClassName, !!itemClassName), _defineProperty(_obj, "text-sm font-semibold flex flex-1 items-center justify-center", true), _defineProperty(_obj, "px-1 py-3 rounded-full", true), _defineProperty(_obj, "transition ease-in-out duration-150", true), _defineProperty(_obj, "cursor-pointer", value !== currValue), _defineProperty(_obj, "text-white bg-opacity-0 cursor-not-allowed", value === currValue), _obj)),
                    children: label
                }, "toggle_".concat(value));
            })
        ]
    });
};


/***/ }),

/***/ 34700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Label(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "text-sm font-medium py-1 mt-2 ".concat(className),
        children: children
    });
};


/***/ }),

/***/ 39800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Radio; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89894);
/* harmony import */ var _hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54731);
/* harmony import */ var _Label__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34700);





function Radio(props) {
    var isDarkMode = (0,_hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Label__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: props.label
            }),
            props.options.map(function(param) {
                var value = param.value, label = param.label, bottomLabel = param.bottomLabel;
                var onClick = function() {
                    return props.onChange(value);
                };
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                        "border rounded-md mb-3": true,
                        "shadow-lg border-gray-200 shadow-gray-200": !isDarkMode && props.value === value,
                        "border-gray-100": !isDarkMode && props.value !== value,
                        "shadow-lg border-gray-400 shadow-gray-700": isDarkMode && props.value === value,
                        "border-gray-700": isDarkMode && props.value !== value
                    }),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                                "flex items-center justify-center px-3 py-4 cursor-pointer transition ease-in-out duration-150": true,
                                "text-gray-900": !isDarkMode && value === props.value,
                                "text-white": isDarkMode && value === props.value
                            }),
                            onClick: onClick,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "p-2 flex flex-col items-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "radio",
                                        value: value,
                                        checked: value === props.value,
                                        onChange: onClick
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                                        "flex-1 text-sm": true,
                                        "text-gray-600": !isDarkMode && value !== props.value,
                                        "text-gray-400": isDarkMode && value !== props.value
                                    }),
                                    children: label
                                })
                            ]
                        }),
                        bottomLabel && props.value === value ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                                "border-b ml-4 mr-4": true,
                                "border-b-gray-100 ": !isDarkMode,
                                "border-b-gray-700": isDarkMode
                            })
                        }) : null,
                        bottomLabel && props.value === value ? bottomLabel : null
                    ]
                }, value);
            })
        ]
    });
};


/***/ }),

/***/ 55615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51649);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5434);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89894);
/* harmony import */ var _hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54731);
/* harmony import */ var _hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1626);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82723);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Label__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34700);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









function Text(props) {
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var isDarkMode = (0,_hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    (0,_hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("Enter", function() {
        if (inputRef.current.focus) {
            props.onEnter && props.onEnter();
        }
    });
    var icon = props.icon;
    if (props.error && !icon) {
        icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_7__/* .IoMdWarning */ .iUH, {
            className: "text-red-700",
            size: 24
        });
    }
    if (props.success && !icon) {
        icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdCheckCircle */ .ZSR, {
            className: "text-green-700",
            size: 24
        });
    }
    var _fieldType, _step;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col relative",
        children: [
            props.label ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Label__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: props.label
            }) : null,
            icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pointer-events-none py-3 pl-3 absolute",
                children: icon
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({
                ref: inputRef,
                className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                    "border rounded-md px-3 py-3 focus:input-v3": true,
                    "pl-10": icon,
                    "bg-gray-700 border-gray-700 placeholder:text-gray-400": isDarkMode,
                    "border-gray-200 placeholder:text-gray-300": !isDarkMode
                }),
                type: (_fieldType = props.fieldType) !== null && _fieldType !== void 0 ? _fieldType : "text",
                value: props.value || "",
                placeholder: props.placeholder,
                onChange: function(event) {
                    return props.onChange(event.target.value);
                },
                disabled: props.disabled,
                step: (_step = props.step) !== null && _step !== void 0 ? _step : "1"
            }, lodash_omit__WEBPACK_IMPORTED_MODULE_5___default()(props.passProps, [
                "error",
                "success"
            ]))),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "description",
                children: props.description
            }),
            props.errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "os-input-error",
                children: props.errorMessage
            })
        ]
    });
};


/***/ }),

/***/ 41695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ canDeliverNow; }
/* harmony export */ });
/* harmony import */ var _isStoreOpenNow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34490);

function canDeliverNow(store) {
    var noAnticipationNeeded = store && !store.minimumAnticipationDays;
    var isOpenNow = (0,_isStoreOpenNow__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(store);
    var canDeliverNow1 = isOpenNow && noAnticipationNeeded;
    return canDeliverNow1;
};


/***/ }),

/***/ 7281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ canSchedule; }
/* harmony export */ });
function canSchedule(store) {
    var hasScheduleOrderOption = store && store.availableScheduleDaysOptions && store.availableScheduleDaysOptions.length > 0;
    return hasScheduleOrderOption;
};


/***/ }),

/***/ 34490:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var isStoreOpenNow = function(store) {
    var ref;
    var itsOpenNow = store === null || store === void 0 ? void 0 : (ref = store.schedule) === null || ref === void 0 ? void 0 : ref.itsOpenNow;
    return itsOpenNow;
};
/* harmony default export */ __webpack_exports__["Z"] = (isStoreOpenNow);


/***/ }),

/***/ 3943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HC": function() { return /* binding */ getSchedulingDays; },
/* harmony export */   "UM": function() { return /* binding */ getTimeValue; },
/* harmony export */   "sC": function() { return /* binding */ isValidTime; }
/* harmony export */ });
/* harmony import */ var _helpers_dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70457);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81763);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber__WEBPACK_IMPORTED_MODULE_1__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


function isValidTime(time, maxDaysPreference) {
    try {
        var ref = _slicedToArray(time.split("+"), 2), timePart = ref[0], daysPart = ref[1];
        if (!timePart || timePart === "null" || daysPart === "null") return false;
        if (daysPart) {
            if (!lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default()(Number(daysPart))) return false;
            if (Number(daysPart) > maxDaysPreference) return false;
        }
        return true;
    } catch (error) {
        console.log("Error:", error);
        return false;
    }
}
function getTimeValue(time) {
    if (!time || time === "now") {
        return {
            days: "0",
            time: (0,_helpers_dayjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().format("HH:mm")
        };
    }
    var ref = _slicedToArray(time.split("+"), 2), timePart = ref[0], datePart = ref[1];
    return {
        days: datePart || "0",
        time: timePart || (0,_helpers_dayjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().format("HH:mm")
    };
}
var SCHEDULING_PREFERENCE_MAX_INDEX = 46;
function getSchedulingDays(preferences) {
    var ref;
    return ((preferences === null || preferences === void 0 ? void 0 : (ref = preferences.store) === null || ref === void 0 ? void 0 : ref.schedulingOrdersDays) || SCHEDULING_PREFERENCE_MAX_INDEX) - 1;
}


/***/ }),

/***/ 50900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCountryCode; }
/* harmony export */ });
function useCountryCode() {
    // not ideal, maybe improve later
    return (__webpack_require__.g.currentLocale || "es_CL").split("_")[1];
};


/***/ })

}]);